import functionRepo from "./functionRepository";

const values = {};

const getEventName = (key) => `DATASTORE_${key}`;

export default {
    set(key, value){
        values[key] = value;
        
        //Alert our watchers of the occured change
        functionRepo.execute(getEventName(key), value);
    },
    get(key){
        return values[key];
    },
    startWatch(key, callback){
        return functionRepo.subscribe((value) => {
            callback(value); 
        }, getEventName(key)); 
    },
    stopWatch(id){
        return functionRepo.unsubscribe(id);
    }
};